import { type FC, type MouseEventHandler, type MouseEvent } from 'react';
import { trackEvent } from 'dibs-tracking';
import { graphql, useFragment } from 'react-relay';

// components
import { Breadcrumbs, type BreadcrumbsProps } from 'dibs-elements/exports/Breadcrumbs.tsx';

// types
import { type PdpRespSharedBreadcrumbs_item$key as Item } from './__generated__/PdpRespSharedBreadcrumbs_item.graphql.ts';

const trackBreadcrumbClick = (key: string, event: MouseEvent<Element> | null = null): void => {
    trackEvent(
        {
            category: 'navigation',
            action: 'breadcrumb click',
            label: `pdp|${key}`,
        },
        event
    );
};

const itemQuery = graphql`
    fragment PdpRespSharedBreadcrumbs_item on Item {
        breadcrumbs {
            text
            path
            isLinkable
        }
    }
`;

export const PdpRespSharedBreadcrumbs: FC<{ item: Item }> = ({ item: itemRef }) => {
    const item = useFragment(itemQuery, itemRef);
    const breadcrumbs = item?.breadcrumbs || [];

    const handleBreadcrumbClick: MouseEventHandler<HTMLAnchorElement> = (e): void => {
        const index = breadcrumbs.findIndex(({ path }) => {
            return path === (e.target as HTMLAnchorElement).pathname;
        });
        const trackingKey = index === 0 ? 'home' : `l${index}`;
        trackBreadcrumbClick(trackingKey, e);
    };

    return (
        <Breadcrumbs
            isLastItemActive
            onClick={handleBreadcrumbClick}
            breadcrumbs={breadcrumbs as BreadcrumbsProps['breadcrumbs']}
        />
    );
};
